export type EditorMode = 'flat' | 'rendering' | 'preview' | 'render-failed';

export type EditorEvent =
  | { readonly type: 'select'; readonly nodeId: string }
  | { readonly type: 'deselect' }
  | { readonly type: 'clearSelection' }
  | { readonly type: 'mutate' }
  | { readonly type: 'renderSettled'; readonly revision: number }
  | { readonly type: 'renderFailed'; readonly revision: number }
  | { readonly type: 'previewHit'; readonly nodeId: string }
  | { readonly type: 'previewMiss' }
  | { readonly type: 'retry' }
  | { readonly type: 'backToEdit' };

export interface TransitionState {
  readonly mode: EditorMode;
  readonly revision: number;
  readonly selectedNodeId: string | null;
}

/** 명시적 전환(T2). 스펙 §6-2 표 그대로. 늦은 렌더 결과(revision 불일치)는 무시한다. */
export const transition = (state: TransitionState, event: EditorEvent): TransitionState => {
  switch (event.type) {
    case 'select':
    case 'previewHit':
      return { ...state, mode: 'flat', selectedNodeId: event.nodeId };
    case 'deselect':
      return state.mode === 'flat' ? { ...state, mode: 'rendering', selectedNodeId: null } : state;
    case 'clearSelection':
      // 목업 위 바로 편집(고객 에디터) — 선택만 풀고 평면 편집에 머문다. 느린 곡면 렌더로 넘어가지 않는다.
      return { ...state, mode: 'flat', selectedNodeId: null };
    case 'mutate': {
      const revision = state.revision + 1;
      if (state.mode === 'preview' || state.mode === 'rendering')
        return { ...state, mode: 'rendering', revision };
      return { ...state, mode: 'flat', revision };
    }
    case 'renderSettled':
      return state.mode === 'rendering' && event.revision === state.revision
        ? { ...state, mode: 'preview' }
        : state;
    case 'renderFailed':
      return state.mode === 'rendering' && event.revision === state.revision
        ? { ...state, mode: 'render-failed' }
        : state;
    case 'previewMiss':
      return state;
    case 'retry':
      return state.mode === 'render-failed' ? { ...state, mode: 'rendering' } : state;
    case 'backToEdit':
      return { ...state, mode: 'flat' };
  }
};
